import { ENDPOINT, HTTP } from "../config"
import { fetchFromLawfeed } from "../fetchFromLawfeed"



export const getCase = async (idUSer) => {
    console.log("user_id", idUSer)
        const response = await fetchFromLawfeed({
        method: HTTP.GET,
        endpoint: ENDPOINT.getCase + idUSer,
        })
        return response.list
    }